module.exports = __webpack_public_path__ + "img/motionpay.d3002c07.svg";